import {
  Checkbox,
  CheckboxProps,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
} from "@chakra-ui/react";
import React from "react";

type Props = CheckboxProps & {
  helpText?: string;
  label: string;
  error?: {
    message?: string;
  };
};

export const BooleanInput = React.forwardRef((props: Props, ref: any) => {
  const { helpText, label, error, name, ...rest } = props;
  return (
    <FormControl isInvalid={Boolean(error)}>
      <FormLabel htmlFor={name}>{label}</FormLabel>
      <Checkbox
        id={name}
        ref={ref}
        name={name}
        borderColor={error ? "red.500" : undefined}
        {...rest}
      />
      <FormErrorMessage>{error?.message}</FormErrorMessage>
      {helpText && <FormHelperText>{helpText}</FormHelperText>}
    </FormControl>
  );
});
BooleanInput.displayName = "BooleanInput";

export default BooleanInput;
